module.exports = __webpack_public_path__ + "img/service_img12.8ca4fa9f.png";